// src/shared/utils/phoneUtils.ts

/**
 * Safely extracts a phone number from various data formats
 */
export const getPhoneNumber = (item: any): string => {
  // 1. Check if phones array exists (API format)
  if (item.phones && Array.isArray(item.phones) && item.phones.length > 0) {
    const firstPhone = item.phones[0];

    if (typeof firstPhone === "object" && firstPhone !== null) {
      // Check for phone property
      if ("phone" in firstPhone) {
        const phone = firstPhone.phone;
        if (phone && phone !== "N/A" && phone !== "null" && phone !== "undefined") {
          return phone;
        }
      }
    }

    if (typeof firstPhone === "string") {
      return firstPhone;
    }
  }

  // 2. Check phoneNumber field (transformed data)
  if (item.phoneNumber) {
    const phone = item.phoneNumber;
    if (phone && phone !== "N/A" && phone !== "null" && phone !== "undefined") {
      return phone;
    }
  }

  // 3. Check phone field directly
  if (item.phone) {
    const phone = item.phone;
    if (phone && phone !== "N/A" && phone !== "null" && phone !== "undefined") {
      return phone;
    }
  }

  // 4. Check phone_number field (snake_case)
  if (item.phone_number) {
    const phone = item.phone_number;
    if (phone && phone !== "N/A" && phone !== "null" && phone !== "undefined") {
      return phone;
    }
  }

  return "N/A";
};

/**
 * Ensures the phones array is preserved in the data
 */
export const ensurePhonesData = <T extends Record<string, any>>(item: T): T => {
  // If the item has phones, keep it
  if (item.phones && Array.isArray(item.phones) && item.phones.length > 0) {
    return item;
  }

  // If there's a phoneNumber, create a phones array
  if (item.phoneNumber && item.phoneNumber !== "N/A" && item.phoneNumber !== "undefined") {
    return {
      ...item,
      phones: [{ phone: item.phoneNumber, isPrimary: true }],
    };
  }

  return item;
};
